module.exports = __webpack_public_path__ + "img/4_3d02db7d8.png";